export interface IDataMeiosPagamento {
    id: number,
    nome: string,
    flg_usa_receber: "S" | "N",
    flg_usa_pagar: "S" | "N",
    flg_cartao_credito: "S" | "N",
    flg_cheque: "S" | "N"
}

export const defValueMeiosPagamento : IDataMeiosPagamento = {
    id: 0,
    nome: '',
    flg_usa_receber: 'N',
    flg_cartao_credito: 'N',
    flg_cheque: 'N',
    flg_usa_pagar: 'N'
}